import type { Suit } from '@durakapp/engine';

export function suitColor(suit: Suit): string {
  return suit === 'hearts' || suit === 'diamonds' ? 'var(--color-coral)' : 'var(--color-tg-blue)';
}
